import { AppDispatch } from '../../data/store';
import { WebSocketSessionInfo } from './webSocketService';
import * as accountingSlice from '../../data/accounting.slice';

interface IProviderInvoiceDetail {
  providerInvoiceID: number;
  userAccountID: number | null;
}

enum ProviderInvoiceEventType {
  ProviderInvoiceAssigned = 'ProviderInvoiceAssigned',
}

/**
 * Method for handling all ProviderInvoice Events
 * @param sessionInfo The webSocketService sessionInfo object. Contains data copied over from the Redux store as needed
 * @param dispatch The Redux store dispatch function
 * @param detailType A string representing the type of event. Must be one of the ProviderInvoiceEventType enum values
 * @param detail An object containing the event data
 */
function updateProviderInvoice(
  sessionInfo: WebSocketSessionInfo,
  dispatch: AppDispatch,
  detailType: string,
  detail: IProviderInvoiceDetail,
) {
  switch (detailType) {
    case ProviderInvoiceEventType.ProviderInvoiceAssigned:
      // Refetch the needs review list when a provider invoice is assigned
      // Use stored params to preserve the current view (including groupByProvider)
      dispatch((dispatch: AppDispatch, getState: () => any) => {
        const state = getState();
        const needsReviewParams = state.accounting.needsReviewParams;
        dispatch(
          accountingSlice.fetchNeedsReviewAsync(needsReviewParams || {}),
        );
      });
      break;
    default:
      break;
  }
}

export { ProviderInvoiceEventType, updateProviderInvoice };
